import {Injectable} from '@angular/core';
import {CallNumber} from '@ionic-native/call-number/ngx';
import {Platform} from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class CallContactService {

    constructor(private callNumber: CallNumber,
                private platform: Platform) {
    }

    callContact(phone: any) {
        console.log(phone);
        if ((this.platform.is('android') || this.platform.is('ios'))) {
            this.callNumber.callNumber(phone, true)
                .then(() => console.log('Ok'))
                .catch(() => console.log('Error'));
        } else {
            document.location.href = 'tel:' + phone;
        }
    }
}
